import logo from 'assets/images/TTE.png';

const Logo = () => {
  return <img src={logo} alt="Berry" width="160px" />;
};

export default Logo;
